import { render, staticRenderFns } from "./CheckoutIntro.vue?vue&type=template&id=587dbcbb&scoped=true"
import script from "./CheckoutIntro.vue?vue&type=script&lang=js"
export * from "./CheckoutIntro.vue?vue&type=script&lang=js"
import style0 from "./CheckoutIntro.vue?vue&type=style&index=0&id=587dbcbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587dbcbb",
  null
  
)

export default component.exports